import { PreferencesContext } from "../../contexts/PreferencesContext"; //* Library Imports
import { Component } from 'react';
import { connect } from "react-redux";

//* Constants Imports
import { URL } from '../../variables';

//*Services Imports
import { logout } from '../../actions/AppActions';

//* Icons Imports
import { MdSave, MdSettings } from 'react-icons/md';
import { FaFileAlt, FaAward, FaEdit } from 'react-icons/fa';

//* Components
import CircularProgress from "@material-ui/core/CircularProgress";
import { Form, Button, Alert } from "react-bootstrap";
import { translateFeatureLabel, translateModuleDescription, translateModuleLabel, translateSubFeatureLabel } from '../../i18n/adminTranslationHelpers';

class FaculdadeConfiguracoes extends Component {static contextType = PreferencesContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      success: false,
      error: "",
      modules: [],
      config: {},
      faculdade_id: props.user?.faculdade_id || props.faculdade_id
    };
  }

  componentDidMount() {
    this.loadModules();
  }
  loadModules = () => {
    this.setState({ loading: true });
    fetch(`${URL}api/private/faculdades/${this.state.faculdade_id}/modules`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${this.props.token}`
      }
    }).
    then(async (response) => {
      try {
        let resp = await response.json();
        if (resp.message === "Unauthenticated.") {
          this.props.logout();
          return;
        }
        if (resp.result && resp.data) {
          this.setState({
            modules: resp.data.modules || [],
            loading: false
          });
        } else {
          this.setState({
            error: this.context.t("error_loading_modules"),
            loading: false
          });
        }
      } catch (err) {
        this.setState({
          error: this.context.t("error_loading_modules"),
          loading: false
        });
      }
    }).
    catch(() => {
      this.setState({
        error: this.context.t("error_loading_modules"),
        loading: false
      });
    });
  };

  handleInputChange = (field, value) => {
    this.setState({
      config: {
        ...this.state.config,
        [field]: value
      }
    });
  };

  handleModuleToggle = (moduleId, permissionEnabled) => {
    const updatedModules = this.state.modules.map((module) => {
      if (module.id === moduleId) {
        return { ...module, permissionEnabled };
      }
      return module;
    });
    this.setState({ modules: updatedModules });
  };

  handleFeatureToggle = (moduleId, featureId, enabled) => {
    const updatedModules = this.state.modules.map((module) => {
      if (module.id === moduleId) {
        const updatedFeatures = module.features.map((feature) => {
          if (feature.id === featureId) {
            return { ...feature, permissionEnabled: enabled };
          }
          return feature;
        });
        return { ...module, features: updatedFeatures };
      }
      return module;
    });
    this.setState({ modules: updatedModules });
  };

  handleSubFeatureToggle = (moduleId, featureId, subFeatureId, enabled) => {
    const updatedModules = this.state.modules.map((module) => {
      if (module.id === moduleId) {
        const updatedFeatures = module.features.map((feature) => {
          if (feature.id === featureId) {
            const updatedSubFeatures = feature.subFeatures.map((subFeature) => {
              if (subFeature.id === subFeatureId) {
                return { ...subFeature, permissionEnabled: enabled };
              }
              return subFeature;
            });
            return { ...feature, subFeatures: updatedSubFeatures };
          }
          return feature;
        });
        return { ...module, features: updatedFeatures };
      }
      return module;
    });
    this.setState({ modules: updatedModules });
  };

  getIconComponent = (iconName) => {
    const icons = {
      FaFileAlt: FaFileAlt,
      FaAward: FaAward,
      FaEdit: FaEdit
    };
    const IconComponent = icons[iconName];
    return IconComponent ? <IconComponent /> : <MdSettings />;
  };

  buildPermissionsArray = () => {
    const permissions = [];

    this.state.modules.forEach((module) => {
      permissions.push({
        module_id: module.id,
        enabled: module.permissionEnabled
      });

      // Adicionar permissões das features
      if (module.features && module.features.length > 0) {
        module.features.forEach((feature) => {
          permissions.push({
            feature_id: feature.id,
            enabled: feature.permissionEnabled
          });

          // Adicionar permissões das sub-features
          if (feature.subFeatures && feature.subFeatures.length > 0) {
            feature.subFeatures.forEach((subFeature) => {
              permissions.push({
                sub_feature_id: subFeature.id,
                enabled: subFeature.permissionEnabled
              });
            });
          }
        });
      }
    });
    return permissions;
  };

  salvarConfiguracoes = () => {
    this.setState({ saving: true, error: "", success: false });

    //* Construir array de permissões
    const permissions = this.buildPermissionsArray();

    //* Salvar permissões dos módulos
    fetch(
      `${URL}api/private/faculdades/${this.state.faculdade_id}/modules/permissions`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.props.token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ permissions })
      }
    ).
    then(async (response) => {
      try {
        const resp = await response.json();

        if (resp.message === "Unauthenticated.") {
          this.props.logout();
          return;
        }
        if (resp.result) {
          const { total_processed, failed_updates } = resp.data;
          if (failed_updates === 0) {
            this.setState({
              success: true,
              saving: false
            });
            setTimeout(() => {
              this.setState({ success: false });
            }, 3000);
            //! Recarregar módulos após salvar
            this.loadModules();
          } else {
            this.setState({
              error: `${this.context.t("error_saving_permissions_prefix")} ${failed_updates} ${this.context.t("error_saving_permissions_middle")} ${total_processed} ${this.context.t("error_saving_permissions_suffix")}`,
              saving: false
            });
          }
        } else {
          this.setState({
            error: resp.message || this.context.t("error_saving_settings"),
            saving: false
          });
        }
      } catch (err) {
        this.setState({
          error: this.context.t("error_processing_server_response"),
          saving: false
        });
      }
    }).
    catch(() => {
      this.setState({
        error: this.context.t("error_connecting_server"),
        saving: false
      });
    });
  };

  render() {
    const { modules, loading, saving, success, error } = this.state;

    if (loading && modules.length === 0) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}>

          <div className="text-center">
            <CircularProgress color="primary" />
          </div>
        </div>);

    }

    return (
      <div className="module-card-container">

  <div className="module-breadcrumb">

    <button
            className="breadcrumb-back"
            onClick={() =>
            this.props.setState({
              activeTab: -1
            })
            }>{this.context.t("dashboard")}


          </button>

    <span>/</span>

    <strong>{`
      ${this.context.t("legacy_configuracoes")}
    `}</strong>

  </div>

  <div className="module-title-row">

    <div>

      <h3 style={{ fontWeight: 'bold' }}>{`
        ${this.context.t("legacy_configuracoes")}
      `}</h3>

      <p>{this.context.t("ui_configure_os_modulos_e_funcionalidades_disponiveis_208f88ed")}

            </p>

    </div>

    <button
            className="btn-dashboard-modern"
            onClick={() =>
            this.props.setState({
              activeTab: -1
            })
            }>{`
      ${this.context.t("legacy_dashboard")}
    `}
          </button>

  </div>

  {error &&

        <div className="config-alert error">

      <strong>{this.context.t("label_error")}:</strong> {error}

    </div>

        }

  {success &&

        <div className="config-alert success">

      <strong>{this.context.t("label_success")}:</strong> {this.context.t("ui_configuracoes_salvas_com_sucesso_6f4c5595")}

        </div>

        }

  <div className="config-section">

    <div className="config-section-header">

      <h5>

        <MdSettings />{this.context.t("ui_ativacao_de_modulos_e_funcionalidades_d3a0ba81")}



            </h5>

    </div>

    {modules.length === 0 ?

          <div className="empty-module">

        <div className="empty-module-icon">
          ⚙️
        </div>

        <h3>{this.context.t("ui_nenhum_modulo_disponivel_018261fe")}

            </h3>

        <p>{this.context.t("ui_nao_existem_modulos_disponiveis_para_configuracao_43292f9a")}

            </p>

      </div> :



          <div className="config-modules-grid">

        {modules.map((module) =>

            <div
              key={module.id}
              className="config-module-card">


            <div className="config-module-header">

              <div>

                <h5>
                  {translateModuleLabel(this.context.t, module)}
                </h5>

                <p>
                  {translateModuleDescription(this.context.t, module)}
                </p>

              </div>

              <Form.Check
                  type="switch"
                  id={`module-${module.id}`}
                  checked={module.permissionEnabled}
                  onChange={(e) =>
                  this.handleModuleToggle(
                    module.id,
                    e.target.checked
                  )
                  }
                  disabled={saving} />


            </div>

            {module.permissionEnabled &&
              module.features &&
              module.features.length > 0 &&

              <div className="features-grid">

                  {module.features.map((feature) =>

                <div
                  key={feature.id}
                  className="feature-card">


                      <div className="feature-header">

                        <div className="feature-info">

                          <span
                        style={{
                          color: feature.color
                        }}>

                            {this.getIconComponent(feature.icon)}
                          </span>

                          <span>
                            {translateFeatureLabel(this.context.t, feature)}
                          </span>

                        </div>

                        <Form.Check
                      type="switch"
                      id={`feature-${feature.id}`}
                      checked={feature.permissionEnabled}
                      onChange={(e) =>
                      this.handleFeatureToggle(
                        module.id,
                        feature.id,
                        e.target.checked
                      )
                      }
                      disabled={saving} />


                      </div>

                      {feature.permissionEnabled &&
                  feature.subFeatures &&
                  feature.subFeatures.length > 0 &&

                  <div className="subfeatures-list">

                            {feature.subFeatures.map((subFeature) =>

                    <div
                      key={subFeature.id}
                      className="subfeature-item">


                                <div className="feature-info">

                                  <span
                          style={{
                            color: subFeature.color
                          }}>

                                    {this.getIconComponent(
                            subFeature.icon
                          )}
                                  </span>

                                  <small>
                                    {translateSubFeatureLabel(this.context.t, subFeature)}
                                  </small>

                                </div>

                                <Form.Check
                        type="switch"
                        id={`subfeature-${subFeature.id}`}
                        checked={
                        subFeature.permissionEnabled
                        }
                        onChange={(e) =>
                        this.handleSubFeatureToggle(
                          module.id,
                          feature.id,
                          subFeature.id,
                          e.target.checked
                        )
                        }
                        disabled={saving} />


                              </div>

                    )}

                          </div>

                  }

                    </div>

                )}

                </div>

              }

          </div>

            )}

      </div>

          }

  </div>

  <div className="module-footer-actions">

    <button
            className="btn-module-primary"
            onClick={this.salvarConfiguracoes}
            disabled={saving}>


      {saving ?

            <>

          <CircularProgress
                size={16}
                color="inherit" />


          {this.context.t("action_saving")}...

        </> :



            <>

          <MdSave />{`

          ${this.context.t("legacy_salvar_configuracoes")}

        `}</>

            }

    </button>

  </div>

      </div>);

  }
}

const mapStateToProps = (state) => ({
  token: state.AppReducer.token,
  user: state.AppReducer.user
});

export default connect(mapStateToProps, { logout })(FaculdadeConfiguracoes);
